module.exports = __webpack_public_path__ + "static/FerdiansyahMDPhD-44d71010175ce6f0663e3b0244150a32.jpg";